// extracted by mini-css-extract-plugin
export default {"root":"LayoutAccess_root__XGEgI","logo":"LayoutAccess_logo__sYqSl","contents":"LayoutAccess_contents__nkWIg"};